var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagGb = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F0F0F0",
  d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052B4",
  d: "M3.308 6.259A15.9 15.9 0 0 0 .55 11.826h8.324zM31.449 11.826a15.9 15.9 0 0 0-2.756-5.567l-5.568 5.567zM.551 20.174a15.9 15.9 0 0 0 2.757 5.567l5.567-5.567zM25.741 3.308A15.9 15.9 0 0 0 20.174.55v8.324zM6.259 28.692a15.9 15.9 0 0 0 5.567 2.757v-8.324zM11.826.551a15.9 15.9 0 0 0-5.567 2.757l5.567 5.567zM20.174 31.449a15.95 15.95 0 0 0 5.567-2.757l-5.567-5.567zM23.126 20.174l5.567 5.567a15.9 15.9 0 0 0 2.756-5.567z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D80027",
  d: "M31.865 13.913H18.087V.135a16.2 16.2 0 0 0-4.174 0v13.778H.135a16.2 16.2 0 0 0 0 4.174h13.778v13.778a16.2 16.2 0 0 0 4.174 0V18.087h13.778a16.2 16.2 0 0 0 0-4.174"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#D80027",
  d: "m20.174 20.174 7.14 7.14q.492-.494.94-1.027l-6.113-6.113zM11.826 20.174l-7.14 7.14q.494.492 1.027.94l6.113-6.113zM11.826 11.826l-7.14-7.14q-.492.494-.94 1.027l6.113 6.113zM20.174 11.826l7.14-7.14a16 16 0 0 0-1.027-.94l-6.113 6.113z"
})));
export default SvgFlagGb;